import { cn } from "@/lib/utils";
import kagemMark from "@/assets/kagem-mark.png";

type Size = "sm" | "md" | "lg" | "xl";

const SIZE_CLASSES: Record<Size, { text: string; icon: string; gap: string }> = {
  sm: { text: "text-lg", icon: "h-6 w-6", gap: "gap-1.5" },
  md: { text: "text-2xl", icon: "h-8 w-8", gap: "gap-2" },
  lg: { text: "text-3xl sm:text-5xl", icon: "h-10 w-10 sm:h-12 sm:w-12", gap: "gap-2 sm:gap-3" },
  xl: { text: "text-3xl sm:text-5xl md:text-7xl", icon: "h-12 w-12 sm:h-14 sm:w-14 md:h-20 md:w-20", gap: "gap-2 sm:gap-3 md:gap-4" },
};

interface BrandLogoProps {
  size?: Size;
  showIcon?: boolean;
  className?: string;
}

export function BrandLogo({ size = "md", showIcon = true, className }: BrandLogoProps) {
  const sizes = SIZE_CLASSES[size];

  return (
    <div
      className={cn("inline-flex items-center", sizes.gap, className)}
      aria-label="KAGEM"
      style={{ fontFamily: '"Montserrat", "Inter", sans-serif' }}
    >
      {showIcon && (
        <img
          src={kagemMark}
          alt=""
          aria-hidden="true"
          className={cn("object-contain", sizes.icon)}
        />
      )}
      <span
        className={cn("leading-none text-foreground", sizes.text)}
        style={{ fontWeight: 300, letterSpacing: "0.35em" }}
      >
        KAGEM
      </span>
    </div>
  );
}
